import { PRODUCT_TITLE } from './constants.ts';

type LandingNavProps = {
    /** Positioning classes, so the nav can either sit in the flow or overlay the hero. */
    className?: string;
    showContactLink?: boolean;
};

const LandingNav = ({ className = '', showContactLink = false }: LandingNavProps): JSX.Element => (
    <nav className={`w-full z-20 ${className}`}>
        <div id="main_menu" className="flex justify-between items-center py-4 px-6 md:px-10">
            <div className="flex items-center">
                <a className="text-white font-bold text-2xl md:text-4xl" href="/login">
                    {PRODUCT_TITLE}
                </a>
            </div>
            <div className="flex justify-between items-center">
                <ul className="hidden md:flex space-x-10 items-center mr-10">
                    <li>
                        <a href="/register" className="text-white font-bold">Get started</a>
                    </li>
                    {showContactLink && (
                        <li>
                            <a href="/contact" className="text-white font-bold">Contact us</a>
                        </li>
                    )}
                    <li>
                        <a href="/login" className="text-white font-bold">Login</a>
                    </li>
                </ul>
                <a href="/login" className="text-white font-bold md:hidden">Login</a>
            </div>
        </div>
    </nav>
);

export default LandingNav;
